import { ComponentStyleConfig } from '@chakra-ui/react'
import { Dict } from '@chakra-ui/utils'
import { mode } from '@chakra-ui/theme-tools'
import { progressBarBackgroundImage } from './getRw1MainBackgroundImage'

export const Progress: ComponentStyleConfig = {
  variants: {
    default: (props: Dict) => ({
      filledTrack: {
        backgroundColor: mode(
          'rw1.primary.light.5',
          'rw1.primary.dark.5',
        )(props),
      },
      track: {
        backgroundColor: mode(
          'rw1.secondary.light.1',
          'rw1.secondary.dark.1',
        )(props),
      },
      label: {
        color: mode('rw1.secondary.light.1', 'rw1.secondary.dark.1')(props),
      },
    }),
    paused: (props: Dict) => ({
      filledTrack: {
        backgroundColor: mode(
          'rw1.secondary.light.5',
          'rw1.secondary.dark.5',
        )(props),
      },
      track: {
        backgroundColor: mode(
          'rw1.secondary.light.1',
          'rw1.secondary.dark.1',
        )(props),
      },
      label: {
        color: mode('rw1.secondary.light.1', 'rw1.secondary.dark.1')(props),
      },
    }),
    gradient: (props: Dict) => ({
      filledTrack: {
        ...progressBarBackgroundImage(props),
        transitionDuration: '4.5s'
      },
      track: {
        backgroundColor: mode(
          'rw1.secondary.light.1',
          'rw1.secondary.dark.1',
        )(props),
      },
      label: {
        color: mode('rw1.secondary.light.1', 'rw1.secondary.dark.1')(props),
      },
    }),
  },
  defaultProps: {
    variant: 'default',
  },
}
